"use client";

import React from "react";
import { Drawer } from "vaul";

interface VaulModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  dismissible?: boolean;
  noAnimation?: boolean;
  drawerContentClassname?: string;
  cardClassName?: string;
  /**
   * When `false` prevents vaul from repositioning inputs when the keyboard opens.
   * Set to `false` on iOS to prevent the drawer from being pushed out of frame.
   * @default true
   */
  repositionInputs?: boolean;
  /**
   * When `true`, don't move the drawer upwards if there's space, but rather
   * only change its height so it's fully scrollable when the keyboard is open.
   * Useful on iOS to keep the drawer in place.
   * @default false
   */
  fixed?: boolean;
  defaultOpen?: boolean;
}

/**
 * Shared Vaul modal component
 * Displays a modal drawer at the bottom of the screen with margins
 */
const VaulModal: React.FC<VaulModalProps> = ({
  isOpen,
  onClose,
  children,
  dismissible = true,
  noAnimation = false,
  drawerContentClassname,
  cardClassName,
  repositionInputs,
  fixed,
  defaultOpen = false,
}) => {
  return (
    <div className={noAnimation ? "no-animation" : ""}>
      <Drawer.Root
        open={isOpen}
        onOpenChange={onClose}
        dismissible={dismissible}
        defaultOpen={defaultOpen}
        noBodyStyles={true}
        repositionInputs={repositionInputs}
        fixed={fixed}
      >
        <Drawer.Portal>
          <Drawer.Overlay className="fixed inset-0 bg-black/50 z-50" />
          <Drawer.Content
            className={
              drawerContentClassname
                ? drawerContentClassname
                : "fixed bottom-0 left-0 right-0 z-50 outline-none flex justify-center pb-[calc(var(--felt-safe-area-bottom))] mb-4 px-4"
            }
          >
            <div
              className={
                cardClassName ||
                "bg-surface-elevated rounded-[16px] w-full overflow-hidden"
              }
            >
              {children}
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
};

export default VaulModal;
